import { ChevronLeft, ChevronRight } from "lucide-react";
import { Button } from "@/components/ui/button";

export type Cursors = {
  current?: null | string;
  next?: null | string;
  previous?: null | string;
};

export function CursorPager({
  cursors,
  onNavigate,
  className,
}: {
  cursors: Cursors | null | undefined;
  onNavigate: (cursor: string | null) => void;
  className?: string;
}) {
  const next = cursors?.next ?? null;
  const previous = cursors?.previous ?? null;
  const hasAny = next || previous;
  if (!hasAny) return null;

  return (
    <div className={"flex items-center justify-end gap-2 " + (className ?? "")}>
      <Button
        variant="outline"
        size="sm"
        disabled={!previous}
        onClick={() => onNavigate(previous ?? null)}
      >
        <ChevronLeft className="size-3.5" /> Previous
      </Button>
      <Button
        variant="outline"
        size="sm"
        disabled={!next}
        onClick={() => onNavigate(next ?? null)}
      >
        Next <ChevronRight className="size-3.5" />
      </Button>
    </div>
  );
}
